import React, { useState } from 'react';
import ConsumoAguaList from '../components/ConsumoAguaList';
import ConsumoAguaForm from '../components/ConsumoAguaForm';
import ConsumoAguaIndicadores from '../components/ConsumoAguaIndicadores';
import ConsumoAguaRelatorio from '../components/ConsumoAguaRelatorio';
import { Container, Typography, Box, Button, Collapse } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { actionButtonSx, pageTitleSx } from '../styles/uiTokens';

function ConsumoAguaPage() {
  const [refreshList, setRefreshList] = useState(false);
  const [editingConsumoAgua, setEditingConsumoAgua] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showRelatorio, setShowRelatorio] = useState(false);

  const handleConsumoAguaAdded = () => {
    setRefreshList((prev) => !prev);
    setEditingConsumoAgua(null);
    setShowForm(false);
  };

  const handleEditConsumoAgua = (consumoAgua) => {
    setEditingConsumoAgua(consumoAgua);
    setShowForm(true);
  };

  const handleCancelEditConsumoAgua = () => {
    setEditingConsumoAgua(null);
    setShowForm(false);
  };

  const handleConsumoAguaDeleted = () => {
    setRefreshList((prev) => !prev);
  };

  const handleShowForm = () => {
    setEditingConsumoAgua(null);
    setShowForm(true);
  };

  return (
    <Container sx={{ mt: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h4" gutterBottom sx={pageTitleSx}>
          Consumo de &Aacute;gua
        </Typography>
        {!showForm && (
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              variant="outlined"
              startIcon={<AssessmentIcon />}
              onClick={() => setShowRelatorio((prev) => !prev)}
            >
              {showRelatorio ? 'Ocultar Relatório' : 'Relatório'}
            </Button>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleShowForm}
              sx={actionButtonSx}
            >
              Adicionar Leitura
            </Button>
          </Box>
        )}
      </Box>

      {!showForm && (
        <ConsumoAguaIndicadores refresh={refreshList} />
      )}

      <Collapse in={!showForm && showRelatorio}>
        <ConsumoAguaRelatorio refresh={refreshList} />
      </Collapse>

      {showForm && (
        <ConsumoAguaForm
          onConsumoAguaAdded={handleConsumoAguaAdded}
          initialData={editingConsumoAgua}
          onCancelEdit={handleCancelEditConsumoAgua}
        />
      )}

      {!showForm && (
        <ConsumoAguaList
          refresh={refreshList}
          onEdit={handleEditConsumoAgua}
          onConsumoAguaDeleted={handleConsumoAguaDeleted}
        />
      )}
    </Container>
  );
}

export default ConsumoAguaPage;
